export enum DiscountType {
  fixedAmount = 'fixed_amount',
  percentage = 'percentage',
  fixedDiscountAmount = 'fix_discount_amount',
}

export enum CouponChannel {
  LIGHTNING_DEAL = 'LIGHTNING_DEAL',
  DEAL = 'LIGHTNING_DEAL',
  COUPON = 'COUPON',
  PED = 'PED',
  WS24 = 'WS24',
  WSTD = 'WSTD',
  WSCH = 'WSCH',
}

export const PRICE_SYMBOL = {
  us: '$',
  uk: '£',
  ca: '$',
  eu: '€',
  pl: 'zł',
  fr: '€',
  de: '€',
  vn: '₫',
  cl: '$',
  sg: '$',
  ae: 'AED',
  es: '€',
}

export const COLOR_LABEL = [
  'color',
  'colour',
  'couleur',
  'cor',
  'colore',
  'farbe',
  '색',
  '色',
  'カラー',
  'färg',
  'farve',
]
